import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CrownBannerSection from "./components/CrownBannerSection";
import JobPostSection from "./components/JobPostSection";
import IndustryAdsSection from "./components/IndustryAdsSection";
import SocialStarsSection from "./components/SocialStarsSection";
import WonderfulJobsSection from "./components/WonderfulJobsSection";
import AdvertisementPostSection from "./components/AdvertisementPostSection";
import NewsLotterySection from "./components/NewsLotterySection";
import MarketplaceSection from "./components/MarketplaceSection";
import GlobalFactorySection from "./components/GlobalFactorySection";
import BuyerRequestsSection from "./components/BuyerRequestsSection";
import CommunicationSection from "./components/CommunicationSection";
import DropshippingSection from "./components/DropshippingSection";
import HomeSEO from "./components/HomeSEO";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <HomeSEO />
      <Navbar />
      <main>
        {/* Section 1: Hero */}
        <HeroSection />
        {/* Section 3: Job Post Board */}
        <JobPostSection />
        {/* Section 4: Industry Advertisements */}
        <IndustryAdsSection />
        {/* Section 5: Social Media Stars */}
        <SocialStarsSection />
        {/* Section 6: Wonderful Jobs */}
        <WonderfulJobsSection />
        {/* Section 7: Advertisement Post */}
        <AdvertisementPostSection />
        {/* Section 8: News, Lottery & Investment */}
        <NewsLotterySection />
        {/* Section 9: Global Factory & Seller Marketplace */}
        <GlobalFactorySection />
        {/* Section 9b: Buyer Request Board */}
        <BuyerRequestsSection />
        {/* Section 2: Crown Advertisement & Job Post Banner */}
        <CrownBannerSection />
        {/* Section 10: Buy & Sell Business Ads */}
        <MarketplaceSection />
        {/* Section 10: Boss & Employee Communication */}
        <CommunicationSection />
        {/* Section 11: Warehouse Dropshipping */}
        <DropshippingSection />
      </main>
      <Footer />
    </div>
  );
}
